import { Component } from '@angular/core';

@Component({
  selector: 'app-logo-small',
  template: `
    <div class="center">

    <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.66162 14.4525L15.9633 69.7744L50 98L84.0368 70.0732L92.3385 14.4525L50 2L7.66162 14.4525Z" fill="url(#paint0_linear_1_8295)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M50 2V11.962L62.4525 30.2256L92.3384 14.4525L50 2Z" fill="url(#paint1_linear_1_8295)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M92.3386 14.4524L62.4526 30.2255L84.0369 70.0735L92.3386 14.4524Z" fill="url(#paint2_linear_1_8295)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M62.4525 30.226L50 37.6974V97.9999L84.0368 70.0739L62.4525 30.226Z" fill="url(#paint3_linear_1_8295)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M50 2V11.962L37.5476 30.2256L7.66162 14.4525L50 2Z" fill="url(#paint4_linear_1_8295)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.66162 14.4524L37.5476 30.2255L15.9633 69.6584L7.66162 14.4524Z" fill="url(#paint5_linear_1_8295)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M37.5477 30.226L50.0002 37.6974V97.9979L15.9634 69.6588L37.5477 30.226Z" fill="url(#paint6_linear_1_8295)"/>
      <defs>
        <linearGradient id="paint0_linear_1_8295" x1="50" y1="56.3758" x2="50" y2="9.0564" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FC4B4B"/>
          <stop offset="1" stop-color="#C32541"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1_8295" x1="69.3547" y1="7.18429" x2="59.6615" y2="25.9336" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FC4B4B"/>
          <stop offset="1" stop-color="#C32541"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1_8295" x1="62.4526" y1="58.0361" x2="105.212" y2="38.5496" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FC4B4B"/>
          <stop offset="1" stop-color="#C32541"/>
        </linearGradient>
        <linearGradient id="paint3_linear_1_8295" x1="65.5597" y1="42.6742" x2="39.3998" y2="71.5176" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FC4B4B"/>
          <stop offset="1" stop-color="#C32541"/>
        </linearGradient>
        <linearGradient id="paint4_linear_1_8295" x1="35.4722" y1="5.32066" x2="28.0007" y2="27.7351" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FC4B4B"/>
          <stop offset="1" stop-color="#C32541"/>
        </linearGradient>
        <linearGradient id="paint5_linear_1_8295" x1="21.3238" y1="24.5923" x2="0.228672" y2="49.6641" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FC4B4B"/>
          <stop offset="1" stop-color="#C32541"/>
        </linearGradient>
        <linearGradient id="paint6_linear_1_8295" x1="20.9444" y1="64.2627" x2="37.7105" y2="76.2384" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FC4B4B"/>
          <stop offset="1" stop-color="#C32541"/>
        </linearGradient>
      </defs>
    </svg>
  
    </div>`,
  styleUrls: ['./center.style.css'],
  styles: [
    ':host { display: inline-block; }'
  ]
})
export class LogoSmallComponent {} 